import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import apolloProvider from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/graphql.js?vue3';
import { pinia } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/instance.js?vue3';
import FileTreeBrowser from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/file_tree_browser/file_tree_browser.vue?vue3';

export default async function initFileTreeBrowser(router, options) {
  const el = document.getElementById('js-file-browser');
  if (!el) return false;

  const { projectPath, ref, refType } = options;
  return new Vue({
    el,
    name: 'FileTreeBrowserRoot',
    pinia,
    router,
    apolloProvider,
    computed: {
      visible() {
        const isProjectOverview = this.$route?.name === 'projectRoot';
        return !isProjectOverview;
      },
    },
    render(h) {
      if (!this.visible) return null;

      return h(FileTreeBrowser, {
        props: {
          projectPath,
          currentRef: ref,
          refType,
        },
      });
    },
  });
}
